export const ALL_VIDEOGAMES = 'ALL_VIDEOGAMES';
export const ALL_GENRES = 'ALL_GENRES';
export const ALL_PLATFORMS = 'ALL_PLATFORMS'
export const GAME_BY_NAME = 'GAME_BY_NAME';
export const GAME_BY_ID = 'GAME_BY_ID';
export const CREATE_GAME = 'CREATE_GAME';
export const CLEAR_DETAIL = 'CLEAR_DETAIL';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const FILTER_BY_ORIGIN = 'FILTER_BY_ORIGIN'
export const FILTER_BY_GENRE = 'FILTER_BY_GENRE';
export const ORDER_BY_NAME = 'ORDER_BY_NAME,';
export const ORDER_BY_RATING = 'ORDER_BY_RATING';
export const FILTER_BY_PLATFORMS = 'FILTER_BY_PLATFORMS';